import { render } from "./supply_request.vue?vue&type=template&id=d12a3478&scoped=true"
import script from "./supply_request.vue?vue&type=script&lang=js"
export * from "./supply_request.vue?vue&type=script&lang=js"

import "./supply_request.vue?vue&type=style&index=0&id=d12a3478&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12a3478"]])

export default __exports__